import React from 'react'
import { H3, H5, Text } from '../../../../../../../../../Styles/typography'
import { InfoEl } from './elements'
import LessonStore from '../../stores/LessonStore'
import { Subscribe } from 'unstated'
import DocumentsViewerStore from '../../../../../../../../../Modules/Documents/Viewer/Store/DocumentsViewerStore'
import { getFileIcon } from '../../../../../../../../../Helpers/DocsViewer/Icons'

const Info = ({ chapter, lesson }) => {
  const {
    data: { media = [] },
  } = LessonStore.useContainer()

  return (
    <Subscribe to={[DocumentsViewerStore]}>
      {({ openDocument }) => (
        <InfoEl>
          <Text>{chapter.title}</Text>
          <H3>{lesson.title}</H3>
          <div
            className='description'
            dangerouslySetInnerHTML={{ __html: lesson.description }}
          />
          {Boolean(media?.length) && <H5 bold>Resources</H5>}
          <div className='files'>
            {media.map((file, index) => (
              <div
                className='file'
                key={`file-${index}`}
                onClick={() =>
                  openDocument({
                    name: file.fileName,
                    url: file.location,
                    type: file.fileType,
                  })
                }
              >
                <div
                  className='icon'
                  style={{
                    background: `url(${getFileIcon({
                      type: file.fileType,
                      url: file.location,
                    })}) center center /contain no-repeat`,
                  }}
                />
                <div className='info'>
                  <p>{file.fileName}</p>
                </div>
              </div>
            ))}
          </div>
        </InfoEl>
      )}
    </Subscribe>
  )
}

export default Info
